(function($) {
	$.fn.notieShow = function() {
		setTimeout(function() {
			$(".notie-container").animate({
				top: "10px"
			}, 1000);
		}, 200);
		setTimeout(function() {
			$(".notie-container").animate({
				top: "-100px"
			}, 1000);
		}, 3200);
		setTimeout(function() {
			$(".notie-container").remove();
		}, 4200);
	}
	$.fn.notie = function(options) {
		//定义默认样式
		var defaults = {

		};
		//将自定义样式和默认样式合并到opts中
		var opts = $.extend(defaults, options);
		var _notie = $(this);
		var container = '<div class="notie-container">';
		if (options.background != null && options.background != undefined) {
			container += '<div class="notie-box" style="background:' + options.background + '">';
		} else {
			container += '<div class="notie-box">';
		}
		container += options.msg + '<i class="fa fa-cancel"></i></div></div>';
		$("body").append(container);

		return this;
	}
	$.fn.extend({
		addAnimation: function(animationName, animationDuration, animationTiming, animationDelay, animationCount, animationFillMode, animationPlayState) {
			var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
			var animations = animationName + " " + animationDuration + "s " + animationTiming + " " + animationDelay + "s " + animationCount + " " + animationFillMode + " " + animationPlayState;
			$(this).addClass("animated").css({
				"animation": animations
			}).one(animationEnd, function() {
				//$(this).css("animation","");
			});
		}
	});
	var lazyloadClassName = null;
	var animateClass = ["moveInRight", "bounceInZ"];
	//图片预加载功能
	$.fn.lazyload = function() {
		var length = animateClass.length;
		var random = Math.floor(Math.random() * length);
		var animateClassName = animateClass[random];
		var sTop = document.body.scrollTop || document.documentElement.scrollTop;
		_loadImage(sTop);
		window.onscroll = function() {
			var sTop = document.body.scrollTop || document.documentElement.scrollTop;
			_loadImage(sTop);
		}

		function _loadImage(sTop) {
			var imgList = document.querySelectorAll(".lazyload");
			for (var i = 0; i < imgList.length; i++) {
				var el = imgList[i];
				if (_isToShow(el, sTop)) {
					var imgUrl = el.getAttribute("data-src");
					el.setAttribute("src", imgUrl);
					el.className = el.className.replace("lazyload", "");
				}
			};

			//			var articleList=document.querySelectorAll(".alazyload");
			//			for(var i=0;i<articleList.length;i++){
			//				var el=articleList[i];
			//				if(_isToShow(el,sTop)){
			//					el.style.opacity="1";
			//					el.className = el.className.replace("alazyload",animateClassName);
			//				}
			//			}
		}

		function _isToShow(el, sTop) {
			var coords = el.getBoundingClientRect();
			var wHeight = window.innerHeight || document.documentElement.clientHeight;
			return (coords.top >= 0 && coords.left >= 0 && coords.top <= wHeight);
		}
	};

	(function() {
		'use strict';
		var NSlide = function(container, params) {
			var n = this;
			/*初始化参数*/
			var options = {
				container: container,
				width: 300,
				height: 200,
				sources: [],
				type: "flip"
			};
			var iWrapper = null;
			var iContainer = null;
			/*当前活动页面索引*/
			var activeIndex = 0;
			params = params || {};
			var originParams = {};
			for (var param in params) {
				if (typeof params[param] === 'object') {
					originParams[param] = {};
					for (var deepPa in params[param]) {
						originParams[param][deepPa] = params[param][deepPa];
					}
				} else {
					originParams[param] = params[param];
				}
			};
			for (var opt in options) {
				if (typeof params[opt] === 'object') {
					for (var deepOpt in options[opt]) {
						if (typeof params[opt][deepOpt] === 'undefined') {
							params[opt][deepOpt] = options[opt][deepOpt];
						}
					}
				} else if (typeof params[opt] === 'undefined') {
					params[opt] = options[opt];
				}
			};
			n.params = params;
			n.originParams = originParams;
			/*封装事件*/
			var addEvent = function(element, type, handler, useCapture) {
				if (element.addEventListener) {
					element.addEventListener(type, handler, useCapture);
				} else if (element.attachEvent) {
					element.attach("on" + type, handler);
				}
			};
			/*初始化*/
			var init = function() {
				iContainer = document.querySelector(n.params.container);
				n.iContainer = iContainer;
				iWrapper = document.createElement("div");
				n.iWrapper = iWrapper;
				if(iContainer!=null){
					iContainer.style.width = n.params.width + "px";
				iContainer.style.height = n.params.height + "px";
				iWrapper.style.width = n.params.width + "px";
				iWrapper.style.height = n.params.height + "px";
				iWrapper.style.position = "absolute";
				iWrapper.style.top = "0";
				iWrapper.style.left = "0";
				iWrapper.style.background = "url(" + n.params.sources[activeIndex] + ") 0px 0px no-repeat";
				iWrapper.style.backgroundSize = n.params.width + "px " + window.innerHeight + "px";
				iContainer.appendChild(iWrapper);
				}
				/*防止用户快速重复点击*/
				n.lock = true;
			};

			init();
			return n;
		};
		/*属性*/
		NSlide.prototype = {
			activeIndex: 0,
			animate: function(obj, fn, fnEnd) { /*动画事件*/
				var now = {};
				var a = 0;
				clearInterval(obj.timer);
				obj.timer = setInterval(function() {
					now["x"] = (a += 6);
					if (fn) fn.call(obj, now); /*调用fn对象替换obj，然后执行fn(show) */
					if (now["x"] == 180) {
						clearInterval(obj.timer);
						if (fnEnd) fnEnd.call(obj);
					}
				}, 30);
			},
			flip: function() { /*翻转过渡*/
				var n = this;
				var imgUrl = n.params.sources[n.activeIndex];
				if (!n.lock) return;
				n.lock = false;
				n.iWrapper.style.background = 'none';
				n.iWrapper.innerHTML = "";
				var R = 6;
				var C = 3;
				var lock = R * C;
				for (var i = 0; i < C; i++) {
					for (var j = 0; j < R; j++) {
						/*计算分块的高宽*/
						var wx = Math.ceil(n.params.width / C) * i;
						var wy = Math.ceil(n.params.height / R) * j;
						var div = document.createElement("div");
						div.className = "flip";
						div.style.background = "url(" + imgUrl + ") -" + wx + "px -" + wy + "px no-repeat";
						div.style.backgroundSize = n.params.width + "px " + window.innerHeight + "px";
						div.style.width = Math.ceil(n.params.width / C) + "px";
						div.style.height = Math.ceil(n.params.height / R) + "px";
						div.style.position = "absolute";
						div.style.left = wx + "px";
						div.style.top = wy + "px";
						/*匿名函数，定义完立刻执行*/
						(function(div, wx, wy) {
							div.change = false;
							setTimeout(function() {
								n.animate(div, function(data) {
									/*旋转到一半时替换到下一张图片*/
									if (data.x > 90 && !div.change) {
										div.style.background = "url(" + n.params.sources[n.next()] + ") -" + wx + "px -" + wy + "px no-repeat";
										div.style.backgroundSize = n.params.width + "px " + window.innerHeight + "px";
									}
									if (data.x > 90) {
										div.style.transform = "perspective(500px) rotateY(" + data.x + "deg) scale(-1, 1)";
									} else {
										div.style.transform = "perspective(500px) rotateY(" + data.x + "deg)";
									}
								}, function() {
									/*直到循环到最后一块才执行*/
									if ((--lock) == 0) {
										n.activeIndex = n.next();
										n.lock = true;
									}
								});
							}, (i + j) * 200);
						})(div, wx, wy);
						n.iWrapper.appendChild(div);
						div = null;
					}
				}
			},
			next: function() {
				var n = this;
				return (n.activeIndex + 1) % n.params.sources.length;
			} /*获取下一个页面的索引*/
		};

		window.NSlide = NSlide;
	})();

})(jQuery);